<template>
  <div>
    <div class="body">
      <div v-html="text"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      name: "",
    };
  },
  created() {
    this.getText();
  },
  methods: {
    getText() {
      let code = this.$route.query.code;
      let data = {
        code,
      };
      this.$http.get("/loan/agreementInfo", data).then((res) => {
        if (res.data) {
          this.text = res.data;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.body {
  padding: 20px;
  font-size: 15px;
  line-height: 1.5;

  text {
    color: rgba(0, 0, 0, 0.65);
  }
}
</style>
